module.exports = __webpack_public_path__ + "static/media/icon-lock.65566ae4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preview/icon-lock.svg
// module id = ./src/assets/images/preview/icon-lock.svg
// module chunks = 6